import React, { useState, useCallback } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "400px",
};

const MapModal = ({ isOpen, onClose, initialLat, initialLng, onSaveLatLong }) => {
  const [position, setPosition] = useState({
    lat: parseFloat(initialLat) || 22.5726,
    lng: parseFloat(initialLng) || 88.3639,
  });

  // ✅ Load Google Maps
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyAeQzuOcT3aIg5Ql2__hJ2bDli20jCA-Bo", // <-- Put your key here
  });

  const onMapClick = useCallback((e) => {
    setPosition({
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
    });
  }, []);

  const handleSave = () => {
    onSaveLatLong(position.lat.toFixed(6), position.lng.toFixed(6));
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto bg-black bg-opacity-60">
      <div className="flex items-center justify-center min-h-screen p-4">
        <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl">
          <div className="p-6">
            <h3 className="text-xl font-semibold text-gray-900 border-b pb-3 mb-4">
              Select Coordinates on Map
            </h3>

            {isLoaded ? (
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={position}
                zoom={15}
                onClick={onMapClick}
              >
                <Marker position={position} />
              </GoogleMap>
            ) : (
              <div className="flex items-center justify-center h-80 bg-gray-100">
                <p>Loading Map...</p>
              </div>
            )}

            <p className="mt-3 text-sm text-gray-600">
              Lat: {position.lat.toFixed(6)} | Lng: {position.lng.toFixed(6)}
            </p>

            <div className="flex justify-end space-x-3 mt-6">
              <button
                onClick={onClose}
                className="py-2 px-4 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="py-2 px-4 rounded-md text-sm font-medium text-white bg-green-600 hover:bg-green-700"
              >
                Save Coordinates
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapModal;
